import classnames from 'classnames/bind';
import style from './index.module.scss';
import { cartdata, product } from '../../Net/NetProtocol';
import Common from '../../Common/Common';
import TxtValues from '../../components/TxtValues';

const infoimg = "/images/common/info.png";
const delectimg = '/images/components/inputHintPop/register_error.png';
const className = classnames.bind(style);

interface PropsTarget {
    item:product,
    showPidImage:(imgurl: string)=>void,
    selectProduct:(item:product)=>void
}

const orderstatus = [
    "Unpaid",
    "Unpaid",
    "Approved",
    "Voided",
    "Paid",
    "Unauthorized",
    "Shipped",
    "Refunded"
]

const ShowItems = (props: PropsTarget)=>{
    const { item,showPidImage,selectProduct } = props;
    const NRouter = Common.Common.NRouter;
    const GetImgUrlById = (pid:string, imgid:number):string=>{
        return "/product/product/" + pid + "/" + imgid + ".jpg";
    }
    const ShowImage = (pid:string, imgid:number)=>{
        showPidImage(GetImgUrlById(pid, imgid));
    }
    const datetimetostr = (timed:number)=>{
        let timestr = "";
        let timedts = new Date(timed);
        timestr = timedts.toLocaleDateString() + " " + timedts.toLocaleTimeString();
        return timestr;
    }
    const getstatus = (status:number)=>{
        return orderstatus[status];
    }
    const showProduct = (pid:string)=>{
        Common.Orders.IsShow = false;
        NRouter?.('/Product/'+pid);
    }

    const DelectOrder = ()=>{
        Common.Orders.DelProduct(item.timed);
    }

    const subname = (namestr: string):string=>{
        if(namestr.length > 10){
            return namestr.substring(0, 10)+"..."
        }
        return namestr;
    }

    return(
        <div className={className('datalist')}>
            <div className={className('orderdetails')}>
                <div className={className('left')}>
                    <div className={className('orderid')} >
                        <TxtValues title='OrderId: ' values={item.captureid||item.orderid}/>
                    </div>
                    <div className={className('paymoney')} >
                        <TxtValues title='Payment: ' values={"$" + item.price}/>
                    </div>
                </div>
                <div className={className('right')}>
                    <div className={className('righttop')}>
                        {
                            item.state !== 4 &&
                            <div className={className('imgdiv1')} onClick={DelectOrder}>
                                <img src={delectimg} />
                            </div>
                        }
                        <div className={className('imgdiv2')} onClick={()=>{selectProduct(item)}}>
                            <img src={infoimg} />
                        </div>
                        <div className={className('status')} >
                            <TxtValues title='State: ' values={getstatus(item.state)}/>
                        </div>
                    </div>
                    <div className={className('datetimetxt')}>
                        {datetimetostr(item.timed)}
                    </div>
                </div>
            </div>
            <div className={className('item')}>
            {
                item.shopcart.map((nitem:cartdata,index:number)=>{
                    return(
                    <div className={className('itembox')} key={"p"+index}>
                        <div className={className('picture')}>
                            <img src={GetImgUrlById(nitem.ProductId, nitem.ImgeId)} onClick={()=>ShowImage(nitem.ProductId, nitem.ImgeId)} alt={nitem.ProductId}/>
                        </div>
                        <div className={className('details')} >
                            <div className={className('itemdiv')} >
                                <div className={className('title')}>{"No.: "}<span>{subname(nitem.ProductId)}</span></div>
                                <div className={className('title')}>{"types: "}<span>{nitem.Names}</span></div>
                            </div>
                            <div className={className('itemdiv')} >
                                <div className={className('title')}>{"amount: "}<span>{nitem.Amount}</span></div>
                                <div className={className('title')}>{"price: "}<span>{"$"+(Math.round(nitem.Amount*nitem.Price*100)/100).toString()}</span></div>
                            </div>
                        </div>
                        <div className={className('gobutton')} >
                            <button onClick={()=>{showProduct(nitem.ProductId)}}>details</button>
                        </div>
                    </div>
                    )
                })
            }
            </div>
        </div>
    )
}

export default ShowItems;